import { render, staticRenderFns } from "./button-box.vue?vue&type=template&id=aa018062&scoped=true&"
import script from "./button-box.vue?vue&type=script&lang=ts&"
export * from "./button-box.vue?vue&type=script&lang=ts&"
import style0 from "./button-box.vue?vue&type=style&index=0&id=aa018062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa018062",
  null
  
)

export default component.exports